export const getTotalPages = (meta: any) => {
  if (!meta) {
    return 1;
  }

  return Math.ceil(meta.total / meta.limit);
};
